import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

export interface IEbbPortalEnviron {
    uriApi: string;
    uriEbbFiles: string;
    uriEbbAssets: string;
    uriEbbSpaRedirect: string,
    programTypeCodeOptionSet:string,
    ProgramIsCeaBb: boolean
}

@Injectable({ providedIn: 'root' })
export class AppLoadService {
    static environSettings: IEbbPortalEnviron = {
        uriApi:'',
        uriEbbFiles:'',
        uriEbbAssets:'',
        uriEbbSpaRedirect:'',
        programTypeCodeOptionSet:'',
        ProgramIsCeaBb: false
    } as IEbbPortalEnviron;

    public getEnvironSettings(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (window['ebbApi']) {
                AppLoadService.environSettings.uriApi = window['ebbApi'];
                AppLoadService.environSettings.uriEbbFiles = AppLoadService.environSettings.uriApi.substr(0, AppLoadService.environSettings.uriApi.lastIndexOf('\/'));
                AppLoadService.environSettings.uriEbbAssets = `${AppLoadService.environSettings.uriEbbFiles}/files/portal/assets`;
                AppLoadService.environSettings.uriEbbSpaRedirect =  `${AppLoadService.environSettings.uriEbbFiles}/files/portal/authorization`;
            } else {
                AppLoadService.environSettings.uriApi = `https://${environment.devBaseUrl}/api`;
                AppLoadService.environSettings.uriEbbFiles = '';
                AppLoadService.environSettings.uriEbbAssets = '/assets'
                AppLoadService.environSettings.uriEbbSpaRedirect = 'http://localhost:4577/authorization';
            }

            //cea program
            if (window['program']) {
                AppLoadService.environSettings.programTypeCodeOptionSet = window['program'];
            } else {
                AppLoadService.environSettings.programTypeCodeOptionSet = 'FEMA|EBB|ESS';//default to EBB programs
            }
            const programsSplit = AppLoadService.environSettings.programTypeCodeOptionSet.split('|');
            AppLoadService.environSettings.ProgramIsCeaBb = programsSplit.filter(program => program === 'CEA BB').length >= 1;

            resolve(true);
        });
    }

    public readEnvironSettings(): IEbbPortalEnviron {
        return AppLoadService.environSettings;
    }
}